import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
interface CountdownTimerProps {
  durationMinutes?: number;
  variant?: 'large' | 'small' | 'inline';
  storageKey?: string;
}
export function CountdownTimer({
  durationMinutes = 30,
  variant = 'large',
  storageKey = 'huerta_offer_end'
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    let endTime: number;
    const stored = typeof window !== 'undefined' ? localStorage.getItem(storageKey) : null;
    if (stored) {
      endTime = parseInt(stored, 10);
      if (isNaN(endTime) || endTime < Date.now()) {
        endTime = Date.now() + durationMinutes * 60 * 1000;
        localStorage.setItem(storageKey, endTime.toString());
      }
    } else {
      endTime = Date.now() + durationMinutes * 60 * 1000;
      if (typeof window !== 'undefined') {
        localStorage.setItem(storageKey, endTime.toString());
      }
    }
    const updateTimer = () => {
      const now = Date.now();
      const diff = Math.max(0, endTime - now);
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(diff % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [durationMinutes, storageKey]);
  const pad = (n: number) => n.toString().padStart(2, '0');
  if (variant === 'small') {
    return <span className="inline-flex items-center gap-1 font-mono font-bold tabular-nums" data-id="element-75">
        <Clock className="w-3 h-3" data-id="element-76" />
        {pad(timeLeft.hours)}:{pad(timeLeft.minutes)}:{pad(timeLeft.seconds)}
      </span>;
  }
  if (variant === 'inline') {
    return <span className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-3 py-1 rounded-full text-xs md:text-sm font-bold" data-id="element-77">
        <Clock className="w-4 h-4" data-id="element-78" />
        <span className="font-mono tabular-nums" data-id="element-79">
          {pad(timeLeft.hours)}:{pad(timeLeft.minutes)}:{pad(timeLeft.seconds)}
        </span>
      </span>;
  }
  return <div className="bg-red-50 border-2 border-red-200 rounded-2xl p-4 md:p-5 mb-6" data-id="element-80">
      <p className="text-xs md:text-sm font-bold text-red-700 uppercase tracking-wider mb-3 flex items-center justify-center gap-2" data-id="element-81">
        <Clock className="w-4 h-4 animate-pulse" data-id="element-82" />⏰ La oferta termina en:
      </p>
      <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-83">
        <TimeBlock value={pad(timeLeft.hours)} label="HORAS" data-id="element-84" />
        <span className="text-2xl md:text-4xl font-black text-red-600" data-id="element-85">:</span>
        <TimeBlock value={pad(timeLeft.minutes)} label="MIN" data-id="element-86" />
        <span className="text-2xl md:text-4xl font-black text-red-600" data-id="element-87">:</span>
        <TimeBlock value={pad(timeLeft.seconds)} label="SEG" pulse data-id="element-88" />
      </div>
    </div>;
}
function TimeBlock({
  value,
  label,
  pulse
}: {
  value: string;
  label: string;
  pulse?: boolean;
}) {
  return <div className="flex flex-col items-center" data-id="element-89">
      <div className={`bg-red-600 text-white font-black text-2xl md:text-4xl px-3 py-2 md:px-5 md:py-3 rounded-xl shadow-md min-w-[60px] md:min-w-[80px] text-center font-mono tabular-nums ${pulse ? 'animate-pulse' : ''}`} data-id="element-90">
        {value}
      </div>
      <span className="text-[10px] md:text-xs font-bold text-red-700 mt-1 tracking-wider" data-id="element-91">
        {label}
      </span>
    </div>;
}